import { gql } from '@apollo/client/core'

export const POSTAL_PROCURATION_CONFIRMATION = gql`
  mutation postalProcurationConfirmation($domiciliationId: ID!, $withTampon: Boolean!) {
    postalProcurationConfirmation(domiciliationId: $domiciliationId, withTampon: $withTampon) {
      domiciliation {
        id
        postalProcurationReady
      }
    }
  }
`
